export class TemplateMedicineSubgroupRequest {
    public idMedicineGroup: number;

    public medicineSubgroupName: string;

    public dateTimeInclusion: Date;

    public medicineSubgroupDescription: string;
}